import React from "react";
import { Helmet } from "react-helmet";

export const InitialOfferHelmet = () => (
  <Helmet>
    <meta
      name="description"
      content="This is a guide price based on assumptions we’ve made about your car"
    />
    <title>Initial valuation | Arnold Clark</title>
  </Helmet>
);

export const EstimatedOfferHelmet = () => (
  <Helmet>
    <meta
      name="description"
      content="This is a guide price based on assumptions we’ve made about your car"
    />
    <title>Estimated valuation | Arnold Clark</title>
  </Helmet>
);

export const PersonaliedOfferHelmet = () => (
  <Helmet>
    <meta
      name="description"
      content="This is a guide price based on assumptions we’ve made about your car"
    />
    <title>Personalised valuation | Arnold Clark</title>
  </Helmet>
);

export const TellUsAboutYourCarHelmet = () => (
  <Helmet>
    <meta name="description" content="Tell us about your car" />
    <title>Tell us about your car | Arnold Clark</title>
  </Helmet>
);

export const YourCarConditionHelmet = () => (
  <Helmet>
    <meta name="description" content="Your car's condition" />
    <title>Your car’s condition | Arnold Clark</title>
  </Helmet>
);

export const VehicleDetailsHelmet = () => (
  <Helmet>
    <meta name="description" content="Your vehicle's details" />
    <title>Your vehicle's details | Arnold Clark</title>
  </Helmet>
);

export const MileageHelmet = () => (
  <Helmet>
    <meta
      name="description"
      content="Tell us your car’s mileage for an instant online estimated valuation."
    />
    <title>Enter mileage | Arnold Clark</title>
  </Helmet>
);

export const BranchConfirmationHelmet = () => (
  <Helmet>
    <meta name="description" content="Confirmation" />
    <title>Confirmation | Arnold Clark</title>
  </Helmet>
);
